<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">
            <b-tabs style="height:100%;">

                <b-tab title="交易行情">
                    <!-- 條件選單 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="trading_quotes.text" :showMore="false"></PwaTitle>
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l4" v-if="trading_quotes.input.type.show">
                                <p>
                                    <label class="global-descript">{{ trading_quotes.input.type.text }}</label>
                                    <v-select class="global-descript" v-model="trading_quotes.input.type.value" :options="trading_quotes.input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 分類 -->
                            <div class="w3-col w3-container m4 l4" v-if="trading_quotes.input.type_sub.show">
                                <p>
                                    <label class="global-descript">{{ trading_quotes.input.type_sub.text }}</label>
                                    <v-select class="global-descript" v-model="trading_quotes.input.type_sub.value" :options="trading_quotes.input.type_sub.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 產品名稱 -->
                            <div class="w3-col w3-container m4 l4" v-if="trading_quotes.input.product.show">
                                <p>
                                    <label class="global-descript">{{ trading_quotes.input.product.text }}</label>
                                    <v-select class="global-descript" v-model="trading_quotes.input.product.value" :options="trading_quotes.input.product.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 市場 -->
                            <div class="w3-col w3-container m4 l4" v-if="trading_quotes.input.market.show">
                                <p>
                                    <label class="global-descript">{{ trading_quotes.input.market.text }}</label>
                                    <v-select class="global-descript" v-model="trading_quotes.input.market.value" :options="trading_quotes.input.market.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                        </div>
                    </b-container>
                    <!-- 價格資訊 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="trading_quotes.trade_day.text" :showMore="false"></PwaTitle> 
                        
                        <!-- 交易日期 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.date.text }}</li>
                                <li class="global-descript"> &nbsp; <b>{{ trading_quotes.trade_day.date.value }}</b></li>
                            </ul>
                        </div>
                        <!-- 均價 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.price_avg.text }}</li>
                                <li class="global-descript">NT＄<b>{{ trading_quotes.trade_day.price_avg.value }}</b></li>
                            </ul>
                        </div>
                        <!-- 交易量 -->
                        <div class="w3-col w3-margin-bottom" style="width:33.33%">
                            <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                                <li class="global-descript">{{ trading_quotes.trade_day.volume.text }}</li>
                                <li class="global-descript"><b>{{ trading_quotes.trade_day.volume.value }}</b> (公斤)</li>
                            </ul>
                        </div>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>       
                    </b-container>
                </b-tab>
                <b-tab title="價量分析">
                    <!-- 條件選單 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.text" :showMore="false"></PwaTitle>
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l4" v-if="price_volume.input.type.show">
                                <p>
                                    <label class="global-descript">{{ price_volume.input.type.text }}</label>
                                    <v-select class="global-descript" v-model="price_volume.input.type.value" :options="price_volume.input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 分類 -->
                            <div class="w3-col w3-container m4 l4" v-if="price_volume.input.type_sub.show">
                                <p>
                                    <label class="global-descript">{{ price_volume.input.type_sub.text }}</label>
                                    <v-select class="global-descript" v-model="price_volume.input.type_sub.value" :options="price_volume.input.type_sub.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 產品名稱 -->
                            <div class="w3-col w3-container m4 l4" v-if="price_volume.input.product.show">
                                <p>
                                    <label class="global-descript">{{ price_volume.input.product.text }}</label>
                                    <v-select class="global-descript" v-model="price_volume.input.product.value" :options="price_volume.input.product.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 市場 -->
                            <div class="w3-col w3-container m4 l4" v-if="price_volume.input.market.show">
                                <p>
                                    <label class="global-descript">{{ price_volume.input.market.text }}</label>
                                    <v-select class="global-descript" v-model="price_volume.input.market.value" :options="price_volume.input.market.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                        </div>
                    </b-container>
                    <!-- 相關圖表 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.week.text" :showMore="false"></PwaTitle> 
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="price_volume.week.descript"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_trading_quotes_week"></div>
                        </div>
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.month.text" :showMore="false"></PwaTitle>
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="price_volume.month.descript"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_price_volume_month"></div>
                        </div>
                        <!-- 標題 -->
                        <PwaTitle :textTitle="price_volume.year.text" :showMore="false"></PwaTitle>
                        <!-- 簡述 -->
                        <div class="global-descript" v-html="price_volume.year.descript"></div>
                        <!-- 圖表 -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                            <div id="chart_price_volume_year"></div>
                        </div>
                    </b-container>    
                </b-tab>
                <b-tab title="其他資訊">
                    <!-- 條件選單 -->
                    <b-container fluid class="pb-3">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.text" :showMore="false"></PwaTitle>
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l4" v-if="other_info.input.type.show">
                                <p>
                                    <label class="global-descript">{{ other_info.input.type.text }}</label>
                                    <v-select class="global-descript" v-model="other_info.input.type.value" :options="other_info.input.type.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 分類 -->
                            <div class="w3-col w3-container m4 l4" v-if="other_info.input.type_sub.show">
                                <p>
                                    <label class="global-descript">{{ other_info.input.type_sub.text }}</label>
                                    <v-select class="global-descript" v-model="other_info.input.type_sub.value" :options="other_info.input.type_sub.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 產品名稱 -->
                            <div class="w3-col w3-container m4 l4" v-if="other_info.input.product.show">
                                <p>
                                    <label class="global-descript">{{ other_info.input.product.text }}</label>
                                    <v-select class="global-descript" v-model="other_info.input.product.value" :options="other_info.input.product.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                            <!-- 市場 -->
                            <div class="w3-col w3-container m4 l4" v-if="other_info.input.market.show">
                                <p>
                                    <label class="global-descript">{{ other_info.input.market.text }}</label>
                                    <v-select class="global-descript" v-model="other_info.input.market.value" :options="other_info.input.market.list" :reduce="(option) => option.value" label="text"></v-select>
                                </p>
                            </div>
                        </div>
                    </b-container>
                    <!-- 相關圖表 -->
                    <!-- 家畜產值(牛、豬、羊) -->
                    <b-container fluid class="pb-3" v-show="other_info.livestock_production_quantity.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.livestock_production_quantity.year + '年 家畜產值-' + other_info.livestock_production_quantity.animal" :showMore="false"></PwaTitle>
                        <!--
                        <p v-show="other_info.input.type.value == '牛'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=569">農業部農業資料開放平台</a></p> 
                        <p v-show="other_info.input.type.value == '豬'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=569">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '羊'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=569">農業部農業資料開放平台</a></p>
                        -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_intelligence_livestock_production_quantity"></div>
                        </div>
                    </b-container>

                    <!-- 家畜飼養場數(種類)(牛、豬、羊) -->
                    <b-container fluid class="pb-3" v-show="other_info.livestock_field_quantity.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.livestock_field_quantity.year + '年 家畜飼養場數-' + other_info.livestock_field_quantity.animal" :showMore="false"></PwaTitle>
                        <!--
                        <p v-show="other_info.input.type.value == '牛'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=565">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '豬'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=565">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '羊'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=565">農業部農業資料開放平台</a></p>
                        -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_intelligence_livestock_field_quantity"></div>
                        </div>
                    </b-container>

                    <!-- 家畜飼養場數(分類)(乳牛、肉牛) -->
                    <b-container fluid class="pb-3" v-show="other_info.livestock_field_quantity2.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.livestock_field_quantity2.year + '年 家畜飼養場數-' + other_info.livestock_field_quantity2.animal" :showMore="false"></PwaTitle>
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" v-show="other_info.livestock_field_quantity2.is_result">
                            <div id="chart_intelligence_livestock_field_quantity2"></div>
                        </div>
                    </b-container>

                    <!-- 家畜飼養頭數(牛、豬、羊) -->
                    <b-container fluid class="pb-3" v-show="other_info.livestock_feed_quantity.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.livestock_feed_quantity.year + '年 家畜飼養頭數-' + other_info.livestock_feed_quantity.animal" :showMore="false"></PwaTitle>
                        <!--
                        <p v-show="other_info.input.type.value == '牛'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=566">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '豬'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=566">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '羊'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=566">農業部農業資料開放平台</a></p>
                        -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_intelligence_livestock_feed_quantity"></div>
                        </div>
                    </b-container>
                    
                    <!-- 家禽產值(雞、鴨、鵝) -->
                    <b-container fluid class="pb-3" v-show="other_info.poultry_production_quantity.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.poultry_production_quantity.year + '年 家禽產值-' + other_info.poultry_production_quantity.animal" :showMore="false"></PwaTitle>
                        <!--
                        <p v-show="other_info.input.type.value == '雞'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=570">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '鴨'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=570">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '鵝'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=570">農業部農業資料開放平台</a></p>
                        -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_intelligence_poultry_production_quantity"></div>
                        </div>
                    </b-container>

                    <!-- 家禽供應屠宰隻數(雞、鴨、鵝) -->
                    <b-container fluid class="pb-3" v-show="other_info.poultry_slaughter_quantity.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.poultry_slaughter_quantity.year + '年 家禽供應屠宰隻數-' + other_info.poultry_production_quantity.animal" :showMore="false"></PwaTitle>
                        <!--
                        <p v-show="other_info.input.type.value == '雞'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=575">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '鴨'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=575">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '鵝'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=575">農業部農業資料開放平台</a></p> 
                        -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_intelligence_poultry_slaughter_quantity"></div>
                        </div>
                    </b-container>

                    <!-- 家禽飼養場數(種類)(雞、鴨、鵝) -->
                    <b-container fluid class="pb-3" v-show="other_info.poultry_field_quantity.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.poultry_field_quantity.year + '年 家禽飼養場數-' + other_info.poultry_field_quantity.animal" :showMore="false"></PwaTitle>
                        <!--
                        <p v-show="other_info.input.type.value == '雞'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=567">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '鴨'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=567">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '鵝'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=567">農業部農業資料開放平台</a></p>
                        -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_intelligence_poultry_field_quantity"></div>
                        </div>
                    </b-container>

                    <!-- 家禽飼養場數(分類)(白肉雞、紅羽土雞、黑羽土雞、土番鴨) -->
                    <b-container fluid class="pb-3" v-show="other_info.poultry_field_quantity2.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.poultry_field_quantity2.year + '年 家禽飼養場數-' + other_info.poultry_field_quantity2.animal" :showMore="false"></PwaTitle>
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_intelligence_poultry_field_quantity2"></div>
                        </div>
                    </b-container>

                    <!-- 家禽飼養隻數(種類)(雞、鴨、鵝) -->
                    <b-container fluid class="pb-3" v-show="other_info.poultry_feed_quantity.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.poultry_feed_quantity.year + '年 家禽飼養隻數-' + other_info.poultry_feed_quantity.animal" :showMore="false"></PwaTitle>
                        <!--
                        <p v-show="other_info.input.type.value == '雞'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=568">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '鴨'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=568">農業部農業資料開放平台</a></p>
                        <p v-show="other_info.input.type.value == '鵝'" class="title-data-source">資料來源網址：<a target="_blank" href="https://data.moa.gov.tw/open_detail.aspx?id=568">農業部農業資料開放平台</a></p>
                        -->
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_intelligence_poultry_feed_quantity"></div>
                        </div>
                    </b-container>

                    <!-- 家禽飼養隻數(分類)(白肉雞) -->
                    <b-container fluid class="pb-3" v-show="other_info.poultry_feed_quantity2.is_result">
                        <!-- 標題 -->
                        <PwaTitle :textTitle="other_info.poultry_feed_quantity2.year + '年 家禽飼養隻數-' + other_info.poultry_feed_quantity2.animal" :showMore="false"></PwaTitle>
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_intelligence_poultry_feed_quantity2"></div>
                        </div>
                    </b-container>   
                </b-tab>
            </b-tabs> 
        </div>
    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}                  
    },  
    components: {
        Header,
        PwaTitle,
    },
    data(){
        return {
            title: "畜牧情報站",

            //當日交易行情
            trading_quotes:{
                id:"trading_quotes",
                text:"當日交易行情",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                        show:true,
                    },
                    //分類
                    type_sub:{
                        text:"分類",
                        value:"",
                        placeholder:"請選擇分類",
                        list:[],
                        show:false,
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                        show:false,
                    },
                    //市場
                    market:{
                        text:"市場",
                        value:"",
                        placeholder:"請選擇市場",
                        list:[],
                        show:false,
                    }
                }, 
                //當日交易行情
                trade_day:{
                    text:"作物近期交易資訊",
                    //是否有結果
                    is_result:false,
                    //交易日期
                    date:{
                        text:"交易日期",
                        value:""
                    },
                    //上價(元/公斤)
                    price_c:{
                        text:"上價",
                        value:0
                    },
                    //中價(元/公斤)
                    price_m:{
                        text:"中價",
                        value:0
                    },
                    //下價(元/公斤)
                    price_f:{
                        text:"下價",
                        value:0
                    },
                    //均價(元/公斤)
                    price_avg:{
                        text:"均價",
                        value:0
                    },
                    //交易量(公斤)
                    volume:{
                        text:"交易量",
                        value:0
                    },
                },
            },
            //價量變化分析
            price_volume:{
                id:"price_volume",
                text:"價量變化分析",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                        show:true,
                    },
                    //分類
                    type_sub:{
                        text:"分類",
                        value:"",
                        placeholder:"請選擇分類",
                        list:[],
                        show:false,
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                        show:false,
                    },
                    //市場
                    market:{
                        text:"市場",
                        value:"",
                        placeholder:"請選擇市場",
                        list:[],
                        show:false,
                    }
                },
                //一周(近七日)交易行情
                week:{
                    //是否有結果
                    is_result:false, 
                    text:"一周交易均價變化圖",
                    descript:"近7日交易均價及成交量。"
                },
                //月交易均價分析圖
                month:{
                    //是否有結果
                    is_result:false, 
                    text:"月交易均價分析圖",
                    descript:"近12個月交易均價及成交量。"
                },
                //年交易均價分析圖
                year:{                       
                    //是否有結果
                    is_result:false, 
                    text:"年交易均價分析圖",
                    descript:"近5年交易均價及成交量。"  
                },
            },
            //畜牧其他資訊
            other_info:{
                id:"other_info",
                text:"畜牧其他資訊",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                        show:true,
                    },
                    //分類
                    type_sub:{
                        text:"分類",
                        value:"",
                        placeholder:"請選擇分類",
                        list:[],
                        show:false,
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                        show:false,
                    },
                    //市場
                    market:{
                        text:"市場",
                        value:"",
                        placeholder:"請選擇市場",
                        list:[],
                        show:false,
                    }
                },
                //家畜產值(牛、豬、羊)
                livestock_production_quantity:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家畜(牛、豬、羊)
                    animal:"",  
                },
                //家畜飼養場數(種類)(牛、豬、羊)
                livestock_field_quantity:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家畜(牛、豬、羊)
                    animal:"",  
                },
                //家畜飼養場數(分類)(乳牛、肉牛)
                livestock_field_quantity2:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家畜(牛、豬、羊)
                    animal:"",  
                },
                //家畜飼養場數(分類)(乳牛、肉牛)
                livestock_feed_quantity:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家畜(牛、豬、羊)
                    animal:"",  
                },

                //家禽產值(雞、鴨、鵝)
                poultry_production_quantity:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家禽(雞、鴨、鵝)
                    animal:"",  
                },
                //家禽供應屠宰隻數(雞、鴨、鵝)
                poultry_slaughter_quantity:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家禽(雞、鴨、鵝)
                    animal:"",  
                },
                //家禽飼養場數(種類)(雞、鴨、鵝)
                poultry_field_quantity:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家禽(雞、鴨、鵝)
                    animal:"",  
                },
                //家禽飼養場數(分類)(白肉雞、紅羽土雞、黑羽土雞、土番鴨)
                poultry_field_quantity2:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家禽(雞、鴨、鵝)
                    animal:"",  
                },
                //家禽飼養隻數(種類)(雞、鴨、鵝)
                poultry_feed_quantity:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家禽(雞、鴨、鵝)
                    animal:"",  
                },
                //家禽飼養隻數(分類)(白肉雞)
                poultry_feed_quantity2:{

                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //家禽(白肉雞)
                    animal:"",  
                },
            },

            /*
            //作物種植面積
            crop_area:{
                id:"crop_area",
                text:"作物種植面積",
                //表單物件
                input:{
                    //種類
                    type:{
                        text:"種類",
                        value:"",
                        placeholder:"請選擇種類",
                        list:[],
                    },
                    //產品名稱
                    product:{
                        text:"產品名稱",
                        value:"",
                        placeholder:"請選擇產品名稱",
                        list:[],
                    },
                },
                //全台-縣市面積
                city:{               
                    //是否有結果
                    is_result:false, 
                    //年度
                    year:"",
                    //全國總面積
                    all_area:"",
                    text:"{year}年各縣市種植面積",
                    descript:"全國種植總面積共{area}公頃。",
                },
                //指定縣市-鄉鎮市區面積
                town:{
                    //是否有結果
                    is_result:false,
                    //年度
                    year:"",  
                    //縣市總面積
                    all_area:"",
                    text:"{year}年雲林縣鄉鎮種植面積",
                    descript:"雲林縣種植總面積共{area}公頃。",
                }
            },
            */

            //api 取得漁業情報站預設值(網頁剛載入時，預設選取)
            apiGetIntelligenceLivestock: (data) => this.userRequest.post("/API/Default/GetIntelligenceLivestock", data),
        
            //api 取得種類(該選項相對應的資訊)
            apiGetTradeLivestockTypeInfo: (data) => this.userRequest.post("/API/Default/GetTradeLivestockTypeInfo", data),

            //api 取得分類(該選項相對應的資訊)
            apiGetTradeLivestockTypeSubInfo: (data) => this.userRequest.post("/API/Default/GetTradeLivestockTypeSubInfo", data),

            //api 取得產品名稱(該選項相對應的資訊)
            apiGetTradeLivestockProductInfo: (data) => this.userRequest.post("/API/Default/GetTradeLivestockProductInfo", data),

            //api 取得市場名稱(該選項相對應的資訊)
            apiGetTradeLivestockMarketInfo: (data) => this.userRequest.post("/API/Default/GetTradeLivestockMarketInfo", data),

        }
    },
    watch: {

            //當日交易行情-種類
            "trading_quotes.input.type.value":function(val)
            {
                if(!this.default_load)
                {
                    //分類
                    this.trading_quotes.input.type_sub.value = "";
                    this.trading_quotes.input.type_sub.list = [];
                    this.trading_quotes.input.type_sub.show = false;
                    //產品名稱
                    this.trading_quotes.input.product.value = "";
                    this.trading_quotes.input.product.list = [];
                    this.trading_quotes.input.product.show = false;
                    //市場名稱
                    this.trading_quotes.input.market.value = "";
                    this.trading_quotes.input.market.list = [];
                    this.trading_quotes.input.market.show = false;
                    //當日交易行情
                    this.trading_quotes.trade_day.is_result = false;

                    switch (val) {
                        case "牛":
                        case "雞":
                        case "鴨":
                        case "鵝": 
                            //分類
                            this.trading_quotes.input.type_sub.show = true;
                            //產品名稱
                            this.trading_quotes.input.product.show = true;
                        break;
                        case "豬":
                        case "羊":
                            //產品名稱
                            this.trading_quotes.input.product.show = true;
                            //市場名稱
                            this.trading_quotes.input.market.show = true;   
                        break;
                        default:
                            //產品名稱
                            this.trading_quotes.input.product.show = true;
                            //市場名稱
                            this.trading_quotes.input.market.show = true;  
                        break;
                    }

                    if(val != "")
                    {
                        //取得當日交易行情-種類切換時，要呈現的資訊
                        this.getTradingQuotesTypeInfo();
                    }   
                }
            },
            //當日交易行情-分類
            "trading_quotes.input.type_sub.value":function(val)
            {
                console.log(val);
                if(!this.default_load)
                {
                    //產品名稱
                    this.trading_quotes.input.product.value = "";
                    this.trading_quotes.input.product.list = [];
                    //市場名稱
                    this.trading_quotes.input.market.value = "";
                    this.trading_quotes.input.market.list = [];

                    switch (this.trading_quotes.input.type.value) {
                        case "牛":
                        case "雞":
                        case "鴨":
                        case "鵝": 
                            //取得當日交易行情-分類切換時，要呈現的資訊
                            this.getTradingQuotesTypeSubInfo();
                        break;
                    }
                }
            },
            //當日交易行情-產品名稱
            "trading_quotes.input.product.value":function(val)
            {
                console.log(val);
                if(!this.default_load)
                {
                    //市場名稱
                    this.trading_quotes.input.market.value = "";
                    this.trading_quotes.input.market.list = [];
                    //當日交易行情
                    this.trading_quotes.trade_day.is_result = false;

                    switch (this.trading_quotes.input.type.value) {
                        case "牛":
                        case "豬":
                        case "羊":
                        case "雞": 
                        case "鴨":  
                        case "鵝":    
                            //取得當日交易行情-商品名稱切換時，要呈現的資訊
                            this.getTradingQuotesProductInfo();
                        break;
                    }
                }
            },
            //當日交易行情-市場
            "trading_quotes.input.market.value":function(val)
            {
                console.log(val);
                if(!this.default_load)
                {
                    switch (this.trading_quotes.input.type.value) {
                        case "豬":
                        case "羊":
                            //取得當日交易行情-市場名稱切換時，要呈現的資訊
                            this.getTradingQuotesMarketInfo();
                        break;
                    } 
                }
            },

            //價量變化分析-種類
            "price_volume.input.type.value":function(val)
            {
                if(!this.default_load)
                {
                    //分類
                    this.price_volume.input.type_sub.value = "";
                    this.price_volume.input.type_sub.list = [];
                    this.price_volume.input.type_sub.show = false;
                    //產品名稱
                    this.price_volume.input.product.value = "";
                    this.price_volume.input.product.list = [];
                    this.price_volume.input.product.show = false;
                    //市場名稱
                    this.price_volume.input.market.value = "";
                    this.price_volume.input.market.list = [];
                    this.price_volume.input.market.show = false;
                    //一周交易行情
                    this.price_volume.week.is_result = false;
                    //月交易均價
                    this.price_volume.month.is_result = false;
                    //年交易均價
                    this.price_volume.year.is_result = false;
                    
                    switch (val) {
                        case "牛":
                        case "雞":
                        case "鴨":
                        case "鵝":
                            //分類
                            this.price_volume.input.type_sub.show = true;
                            //產品名稱
                            this.price_volume.input.product.show = true;
                        break;
                        case "豬":
                        case "羊":    
                            //產品名稱
                            this.price_volume.input.product.show = true;
                            //市場名稱
                            this.price_volume.input.market.show = true;   
                        break;
                        default:
                            //產品名稱
                            this.price_volume.input.product.show = true;
                            //市場名稱
                            this.price_volume.input.market.show = true;  
                        break;
                    }

                    if(val != "")
                    {
                        //取得價量變化分析-種類切換時，要呈現的資訊
                        this.getPriceVolumeTypeInfo();
                    }  
                }

            },
            //價量變化分析-分類
            "price_volume.input.type_sub.value":function(val)
            {
                console.log(val);
                if(!this.default_load)
                {
                    //產品名稱
                    this.price_volume.input.product.value = "";
                    this.price_volume.input.product.list = [];
                    //市場名稱
                    this.price_volume.input.market.value = "";
                    this.price_volume.input.market.list = [];

                    switch (this.price_volume.input.type.value) {
                        case "牛":
                        case "雞":
                        case "鴨":
                        case "鵝": 
                            //取得價量變化分析-分類切換時，要呈現的資訊
                            this.getPriceVolumeTypeSubInfo();
                        break;
                    }
                }
            },
            //價量變化分析-產品名稱
            "price_volume.input.product.value":function(val)
            {
                console.log(val);
                if(!this.default_load)
                {
                    //市場名稱
                    this.price_volume.input.market.value = "";
                    this.price_volume.input.market.list = [];
                    //一周交易行情
                    this.price_volume.week.is_result = false;
                    //月交易均價
                    this.price_volume.month.is_result = false;
                    //年交易均價
                    this.price_volume.year.is_result = false;

                    switch (this.price_volume.input.type.value) {
                        case "牛":
                        case "豬":
                        case "羊":
                        case "雞": 
                        case "鴨":
                        case "鵝":     
                            //取得價量變化分析-商品名稱切換時，要呈現的資訊   
                            this.getPriceVolumeProductInfo();
                        break;
                    }
                }
            },
            //價量變化分析-市場
            "price_volume.input.market.value":function(val)
            {
                console.log(val);
                if(!this.default_load)
                {
                    switch (this.price_volume.input.type.value) {
                        case "豬":
                        case "羊":  
                            //取得價量變化分析-市場名稱切換時，要呈現的資訊  
                            this.getPriceVolumeMarketInfo();
                        break;
                    } 
                }

            },

            //畜牧其他資訊-種類
            "other_info.input.type.value":function(val)
            {
                if(!this.default_load)
                {
                    //分類
                    this.other_info.input.type_sub.value = "";
                    this.other_info.input.type_sub.list = [];
                    this.other_info.input.type_sub.show = false;
                    //產品名稱
                    this.other_info.input.product.value = "";
                    this.other_info.input.product.list = [];
                    this.other_info.input.product.show = false;
                    //市場名稱
                    this.other_info.input.market.value = "";
                    this.other_info.input.market.list = [];
                    this.other_info.input.market.show = false;
                    //家畜產值(牛、豬、羊)
                    this.other_info.livestock_production_quantity.is_result = false;
                    //家畜飼養場數(種類)(牛、豬、羊)
                    this.other_info.livestock_field_quantity.is_result = false;
                    //家畜飼養場數(分類)(乳牛、肉牛)
                    this.other_info.livestock_field_quantity2.is_result = false;
                    //家畜飼養頭數(牛、豬、羊)
                    this.other_info.livestock_feed_quantity.is_result = false;
                    //家禽產值(雞、鴨、鵝)
                    this.other_info.poultry_production_quantity.is_result = false;
                    //家禽供應屠宰隻數(雞、鴨、鵝)
                    this.other_info.poultry_slaughter_quantity.is_result = false;
                    //家禽飼養場數(種類)(雞、鴨、鵝)
                    this.other_info.poultry_field_quantity.is_result = false;
                    //家禽飼養場數(分類)(白肉雞、紅羽土雞、黑羽土雞、土番鴨) 
                    this.other_info.poultry_field_quantity2.is_result = false;
                    //家禽飼養隻數(種類)(雞、鴨、鵝)
                    this.other_info.poultry_feed_quantity.is_result = false;
                    //家禽飼養隻數(分類)(白肉雞)
                    this.other_info.poultry_feed_quantity2.is_result = false;
 
                    switch (val) {
                        case "牛":
                        case "雞":
                        case "鴨":
                            //分類
                            this.other_info.input.type_sub.show = true;
                        break;
                    }
                   
                    if(val != "")
                    {
                        //取得畜牧其他資訊-種類切換時，要呈現的資訊
                        this.getOtherInfoTypeInfo();
                    }   
                }
            },
            //畜牧其他資訊-分類
            "other_info.input.type_sub.value":function(val)
            {
                console.log(val);
                if(!this.default_load)
                {
                    //產品名稱
                    this.other_info.input.product.value = "";
                    this.other_info.input.product.list = [];
                    //市場名稱
                    this.other_info.input.market.value = "";
                    this.other_info.input.market.list = [];
                    //家畜飼養場數(分類)(乳牛、肉牛)
                    this.other_info.livestock_field_quantity2.is_result = false;
                    //家禽飼養隻數(分類)(白肉雞)
                    this.other_info.poultry_feed_quantity2.is_result = false;

                    switch (this.other_info.input.type.value) {
                        case "牛":
                        case "雞":
                        case "鴨":
                        case "鵝": 
                            //取得畜牧其他資訊-分類切換時，要呈現的資訊
                            this.getOtherInfoTypeSubInfo();
                        break;
                    }
                }
            },
            //畜牧其他資訊-產品名稱
            "other_info.input.product.value":function(val)
            {
                console.log(val);
                if(!this.default_load)
                {
                    //市場名稱
                    this.other_info.input.market.value = "";
                    this.other_info.input.market.list = [];

                    switch (this.other_info.input.type.value) {
                        case "牛":
                        case "豬":
                        case "羊":
                        case "雞": 
                        case "鴨":  
                        case "鵝":    
                            //取得畜牧其他資訊-商品名稱切換時，要呈現的資訊
                            this.getOtherInfoProductInfo();
                        break;
                    }
                }
            },
            //畜牧其他資訊-市場
            "other_info.input.market.value":function(val)
            {
                console.log(val);
                if(!this.default_load)
                {
                    switch (this.other_info.input.type.value) {
                        case "豬":
                        case "羊":
                            //取得畜牧其他資訊-市場名稱切換時，要呈現的資訊
                            this.getOtherInfoMarketInfo();
                        break;
                    } 
                }
            },

    },
    mounted(){

        this.getIntelligenceLivestock();
    },
    destroyed() {},
    methods: {

        //啟用遮罩
        enableDefaultLoad:function()
        {
            this.enableMask();
            this.default_load = true;
        },
        //取消遮罩
        disableDefaultLoad:function()
        { 
            //暫時先設定延遲，否則watch會重複觸發
            const _this = this;
            window.ThreadTool.Delay(function(){
            
                _this.disableMask();
                _this.default_load = false;

            },this.delay_ms_api);
        },

        //設定當日交易行情-種類
        setTradingQuotesInputType:function(TradeLivestockType)
        {
            this.trading_quotes.input.type.value = "";
            this.trading_quotes.input.type.list = [];
            if(TradeLivestockType.length > 0)
            {
                for(var i=0 ; i<TradeLivestockType.length ; i++)
                {
                    this.trading_quotes.input.type.list.push({value:TradeLivestockType[i].LIVESTOCK_TYPE,text:TradeLivestockType[i].LIVESTOCK_TYPE});
                }
                this.trading_quotes.input.type.value = TradeLivestockType[0].LIVESTOCK_TYPE;
            }
        },
        //設定價量變化分析-種類
        setPriceVolumeInputType:function(TradeLivestockType)
        {
            this.price_volume.input.type.value = "";
            this.price_volume.input.type.list = [];
            if(TradeLivestockType.length > 0)
            {
                for(var i=0 ; i<TradeLivestockType.length ; i++)
                {
                    this.price_volume.input.type.list.push({value:TradeLivestockType[i].LIVESTOCK_TYPE,text:TradeLivestockType[i].LIVESTOCK_TYPE});
                }
                this.price_volume.input.type.value = TradeLivestockType[0].LIVESTOCK_TYPE;
            }
        },
        //設定畜牧其他資訊-種類
        setOtherInfoInputType:function(TradeLivestockType)
        {
            this.other_info.input.type.value = "";
            this.other_info.input.type.list = [];
            if(TradeLivestockType.length > 0)
            {
                for(var i=0 ; i<TradeLivestockType.length ; i++)
                {
                    this.other_info.input.type.list.push({value:TradeLivestockType[i].LIVESTOCK_TYPE,text:TradeLivestockType[i].LIVESTOCK_TYPE});
                }
                this.other_info.input.type.value = TradeLivestockType[0].LIVESTOCK_TYPE;
            }
        },


        //設定當日交易行情-分類
        setTradingQuotesInputTypeSub:function(TradeLivestockTypeSub)
        {
            this.trading_quotes.input.type_sub.value = "";
            this.trading_quotes.input.type_sub.list = [];
            if(TradeLivestockTypeSub.length > 0)
            {
                for(var i=0 ; i<TradeLivestockTypeSub.length ; i++)
                {
                    this.trading_quotes.input.type_sub.list.push({value:TradeLivestockTypeSub[i].LIVESTOCK_TYPE_SUB,text:TradeLivestockTypeSub[i].LIVESTOCK_TYPE_SUB});
                }
                this.trading_quotes.input.type_sub.value = TradeLivestockTypeSub[0].LIVESTOCK_TYPE_SUB;
            }
        },
        //設定價量變化分析-分類
        setPriceVolumeInputTypeSub:function(TradeLivestockTypeSub)
        {
            this.price_volume.input.type_sub.value = "";
            this.price_volume.input.type_sub.list = [];
            if(TradeLivestockTypeSub.length > 0)
            {
                for(var i=0 ; i<TradeLivestockTypeSub.length ; i++)
                {
                    this.price_volume.input.type_sub.list.push({value:TradeLivestockTypeSub[i].LIVESTOCK_TYPE_SUB,text:TradeLivestockTypeSub[i].LIVESTOCK_TYPE_SUB});
                }
                this.price_volume.input.type_sub.value = TradeLivestockTypeSub[0].LIVESTOCK_TYPE_SUB;
            }
        },
        //設定畜牧其他資訊-分類
        setOtherInfoInputTypeSub:function(TradeLivestockTypeSub)
        {
            this.other_info.input.type_sub.value = "";
            this.other_info.input.type_sub.list = [];
            if(TradeLivestockTypeSub.length > 0)
            {
                for(var i=0 ; i<TradeLivestockTypeSub.length ; i++)
                {
                    //以下選項沒資料，故過濾
                    if(["雞蛋","鴨蛋","正番鴨"].indexOf(TradeLivestockTypeSub[i].LIVESTOCK_TYPE_SUB) == -1)
                    {
                        this.other_info.input.type_sub.list.push({value:TradeLivestockTypeSub[i].LIVESTOCK_TYPE_SUB,text:TradeLivestockTypeSub[i].LIVESTOCK_TYPE_SUB});
                    }
                }
                //因為正番鴨沒資料
                if(TradeLivestockTypeSub[0].LIVESTOCK_TYPE_SUB == "正番鴨"){ TradeLivestockTypeSub[0].LIVESTOCK_TYPE_SUB = "土番鴨"; }
                this.other_info.input.type_sub.value = TradeLivestockTypeSub[0].LIVESTOCK_TYPE_SUB;
            }
        },


        //設定當日交易行情-產品名稱
        setTradingQuotesInputProduct:function(TradeLivestockName)
        {   
            this.trading_quotes.input.product.value = "";
            this.trading_quotes.input.product.list = [];
            if(TradeLivestockName.length > 0)
            {
                for(var i=0 ; i<TradeLivestockName.length ; i++)
                {
                    this.trading_quotes.input.product.list.push({value:TradeLivestockName[i].LIVESTOCK_NAME,text:TradeLivestockName[i].LIVESTOCK_NAME});
                }
            } 
            this.trading_quotes.input.product.value = TradeLivestockName[0].LIVESTOCK_NAME;
        },
        //設定價量變化分析-產品名稱
        setPriceVolumeInputProduct:function(TradeLivestockName)
        {
            this.price_volume.input.product.value = "";
            this.price_volume.input.product.list = [];
            if(TradeLivestockName.length > 0)
            {
                for(var i=0 ; i<TradeLivestockName.length ; i++)
                {
                    this.price_volume.input.product.list.push({value:TradeLivestockName[i].LIVESTOCK_NAME,text:TradeLivestockName[i].LIVESTOCK_NAME});
                }
            } 
            this.price_volume.input.product.value = TradeLivestockName[0].LIVESTOCK_NAME;
        },
        //設定畜牧其他資訊-產品名稱
        setOtherInfoInputProduct:function(TradeLivestockName)
        {
            this.other_info.input.product.value = "";
            this.other_info.input.product.list = [];
            if(TradeLivestockName.length > 0)
            {
                for(var i=0 ; i<TradeLivestockName.length ; i++)
                {
                    this.other_info.input.product.list.push({value:TradeLivestockName[i].LIVESTOCK_NAME,text:TradeLivestockName[i].LIVESTOCK_NAME});
                }
            } 
            this.other_info.input.product.value = TradeLivestockName[0].LIVESTOCK_NAME;
        },

        //設定當日交易行情-市場
        setTradingQuotesInputMarket:function(TradeLivestockMarket)
        {
            this.trading_quotes.input.market.value = "";
            this.trading_quotes.input.market.list = [];
            if(TradeLivestockMarket.length > 0)
            {
                for(var i=0 ; i<TradeLivestockMarket.length ; i++)
                {
                    this.trading_quotes.input.market.list.push({value:TradeLivestockMarket[i].LIVESTOCK_MARKET,text:TradeLivestockMarket[i].LIVESTOCK_MARKET});
                }
            } 
            this.trading_quotes.input.market.value = TradeLivestockMarket[0].LIVESTOCK_MARKET;
        },
        //設定價量變化分析-市場
        setPriceVolumeInputMarket:function(TradeLivestockMarket)
        {
            this.price_volume.input.market.value = "";
            this.price_volume.input.market.list = [];
            if(TradeLivestockMarket.length > 0)
            {
                for(var i=0 ; i<TradeLivestockMarket.length ; i++)
                {
                    //當日交易行情-選單-產品名稱
                    this.price_volume.input.market.list.push({value:TradeLivestockMarket[i].LIVESTOCK_MARKET,text:TradeLivestockMarket[i].LIVESTOCK_MARKET});
                }
            } 
            this.price_volume.input.market.value = TradeLivestockMarket[0].LIVESTOCK_MARKET;
        },
        //設定畜牧其他資訊-市場
        setOtherInfoInputMarket:function(TradeLivestockMarket)
        {
            this.other_info.input.market.value = "";
            this.other_info.input.market.list = [];
            if(TradeLivestockMarket.length > 0)
            {
                for(var i=0 ; i<TradeLivestockMarket.length ; i++)
                {
                    this.other_info.input.market.list.push({value:TradeLivestockMarket[i].LIVESTOCK_MARKET,text:TradeLivestockMarket[i].LIVESTOCK_MARKET});
                }
            } 
            this.other_info.input.market.value = TradeLivestockMarket[0].LIVESTOCK_MARKET;
        },

        //取得畜牧情報站預設值
        getIntelligenceLivestock:function()
        {
            this.enableDefaultLoad();

            //當日交易行情-選單-分類
            //價量變化分析-選單-分類
            //畜牧其他資訊-選單-分類
            this.trading_quotes.input.type_sub.show = true;
            this.price_volume.input.type_sub.show = true;
            this.other_info.input.type_sub.show = true;

            //當日交易行情-選單-產品名稱
            //價量變化分析-選單-產品名稱
            //畜牧其他資訊-選單-產品名稱
            this.trading_quotes.input.product.show = true;
            this.price_volume.input.product.show = true;
            //this.other_info.input.product.show = true;

            this.apiGetIntelligenceLivestock({

                LIVESTOCK_TYPE:"牛",
                LIVESTOCK_TYPE_SUB:"乳牛",
                LIVESTOCK_PRODUCT:"乳公架仔牛150-200公斤",
                LIVESTOCK_MARKET:"",
            })
            .then((res)=>{

                //以下先設定為null，因為會發生換頁時，他非null執行updateOptions會報錯，所以統一初始時，幫他設定Null
                //因為Vue是用元件切換，所以在換頁時，default_chart 並不會重載，只有整個重新整理才會重載，所以換頁時時常會出現錯誤

                window.ChartIntelligenceTradingQuotesWeek = null;
                window.ChartIntelligencePriceVolumeMonth = null;
                window.ChartIntelligencePriceVolumeYear = null;

                window.ChartIntelligenceLivestockProductionQuantity = null;
                window.ChartIntelligenceLivestockFieldQuantity = null;
                window.ChartIntelligenceLivestockFieldQuantity2 = null;
                window.ChartIntelligenceLivestockFeedQuantity = null;
                window.ChartIntelligencePoultryProductionQuantity = null;

                window.ChartIntelligencePoultrySlaughterQuantity = null;
                window.ChartIntelligencePoultryFieldQuantity = null;
                window.ChartIntelligencePoultryFieldQuantity2 = null;
                window.ChartIntelligencePoultryFeedQuantity = null;
                window.ChartIntelligencePoultryFeedQuantity2 = null;

                const data = JSON.parse(res.data);

                //當日交易行情-選單-種類
                //價量變化分析-選單-種類
                //畜牧其他資訊-選單-種類
                const TradeLivestockType = data.TradeLivestockType;
                //當日交易行情-選單-分類
                //價量變化分析-選單-分類
                //畜牧其他資訊-選單-分類
                const TradeLivestockTypeSub = data.TradeLivestockTypeSub;
                //當日交易行情-選單-產品名稱
                //價量變化分析-選單-產品名稱
                //畜牧其他資訊-選單-產品名稱
                const TradeLivestockName= data.TradeLivestockName;
                //當日交易行情-選單-市場
                //價量變化分析-選單-市場
                //畜牧其他資訊-選單-市場
                //const TradeLivestockMarket = data.TradeFLivestockMarket;

                //當日交易行情-家畜產值(牛、豬、羊)
                const LivestockProductionQuantity = data.LivestockProductionQuantity;
                //當日交易行情-家畜飼養場數(種類)(牛、豬、羊)
                const LivestockFieldQuantity = data.LivestockFieldQuantity;
                //當日交易行情-家畜飼養場數(分類)(乳牛、肉牛)
                const LivestockFieldQuantity2 = data.LivestockFieldQuantity2;
                //當日交易行情-家畜飼養頭數(牛、豬、羊)
                const LivestockFeedQuantity = data.LivestockFeedQuantity;

                //設定當日交易行情-種類
                this.setTradingQuotesInputType(TradeLivestockType);
                this.trading_quotes.input.type.value = "牛";
                //設定價量變化分析-種類
                this.setPriceVolumeInputType(TradeLivestockType);
                this.price_volume.input.type.value = "牛";
                //設定畜牧其他資訊-種類
                this.setOtherInfoInputType(TradeLivestockType);
                this.other_info.input.type.value = "牛";

                //設定當日交易行情-分類
                this.setTradingQuotesInputTypeSub(TradeLivestockTypeSub);
                this.trading_quotes.input.type_sub.value = "乳牛";
                //設定價量變化分析-分類
                this.setPriceVolumeInputTypeSub(TradeLivestockTypeSub);
                this.price_volume.input.type_sub.value = "乳牛";
                //設定畜牧其他資訊-分類
                this.setOtherInfoInputTypeSub(TradeLivestockTypeSub);
                this.other_info.input.type_sub.value = "乳牛";

                //設定當日交易行情-產品名稱
                this.setTradingQuotesInputProduct(TradeLivestockName);
                this.trading_quotes.input.product.value = "乳公架仔牛150-200公斤";
                //設定價量變化分析-產品名稱
                this.setPriceVolumeInputProduct(TradeLivestockName);
                this.price_volume.input.product.value = "乳公架仔牛150-200公斤";
                //設定畜牧其他資訊-產品名稱
                this.setOtherInfoInputProduct(TradeLivestockName);
                this.other_info.input.product.value = "乳公架仔牛150-200公斤";

                //設定當日交易行情-市場
                //this.setTradingQuotesInputMarket(TradeLivestockMarket);
                //this.trading_quotes.input.market.value = "三重";
                //設定價量變化分析-市場
                //this.setPriceVolumeInputMarket(TradeLivestockMarket);
                //this.price_volume.input.market.value = "三重";
                //設定畜牧其他資訊-市場
                //this.setOtherInfoInputMarket(TradeLivestockMarket);
                //this.other_info.input.market.value = "三重";

                //當日交易行情-當日交易行情
                const TradeDay = data.TradeDay;
                //當日交易行情-一周交易行情
                const TradeWeek = data.TradeWeek;

                //設定當日交易行情-近期交易資訊
                this.setTradeDay(TradeDay);
                //設定當日交易行情-一周交易均價變化圖(沒有交易量)
                this.setTradeWeekNoColumn(TradeWeek);

                //價量變化分析-月交易均價
                const TradeMonth = data.TradeMonth;
                //價量變化分析-年交易均價
                const TradeYear = data.TradeYear;

                //價量變化分析-月交易均價
                this.setTradeMonthNoColumn(TradeMonth);
                //價量變化分析-年交易均價
                this.setTradeYearNoColumn(TradeYear);  

                //畜牧其他資訊-家畜產值(牛、豬、羊)
                this.setLivestockProductionQuantity(LivestockProductionQuantity);
                //畜牧其他資訊-家畜飼養場數(種類)(牛、豬、羊)
                this.setLivestockFieldQuantity(LivestockFieldQuantity);
                //畜牧其他資訊-家畜飼養場數(分類)(乳牛、肉牛)
                this.setLivestockFieldQuantity2(LivestockFieldQuantity2);
                //畜牧其他資訊-家畜飼養頭數(牛、豬、羊)
                this.setLivestockFeedQuantity(LivestockFeedQuantity);

                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
            
        }, 
  

        //取得當日交易行情-種類切換時，要呈現的資訊
        getTradingQuotesTypeInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockTypeInfo({

                LIVESTOCK_TYPE:this.trading_quotes.input.type.value,
                LIVESTOCK_TYPE_SUB:this.trading_quotes.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.trading_quotes.input.product.value,
                LIVESTOCK_MARKET:this.trading_quotes.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定當日交易行情-種類切換時，要呈現的資訊
                this.setTradingQuotesTypeInfo(data);
                //設定當日交易行情-分類切換時，要呈現的資訊
                this.setTradingQuotesTypeSubInfo(data);
                //設定當日交易行情-商品名稱切換時，要呈現的資訊
                this.setTradingQuotesProductInfo(data);
                //設定當日交易行情-市場名稱切換時，要呈現的資訊
                this.setTradingQuotesMarketInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //設定當日交易行情-種類切換時，要呈現的資訊
        setTradingQuotesTypeInfo:function(data){

            //當日交易行情-選單-分類
            const TradeLivestockTypeSub = data.TradeLivestockTypeSub;
            //當日交易行情-選單-產品名稱
            const TradeLivestockName = data.TradeLivestockName;

            //選單部分
            switch(this.trading_quotes.input.type.value){
                case "牛":
                case "雞":
                case "鴨":
                case "鵝":        
                    //設定當日交易行情-分類
                    this.setTradingQuotesInputTypeSub(TradeLivestockTypeSub);    
                break;
                case "豬":
                case "羊":
                    //設定當日交易行情-產品名稱
                    this.setTradingQuotesInputProduct(TradeLivestockName);
                break;
            }
        },
        //取得價量變化分析-種類切換時，要呈現的資訊
        getPriceVolumeTypeInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockTypeInfo({

                LIVESTOCK_TYPE:this.price_volume.input.type.value,
                LIVESTOCK_TYPE_SUB:this.price_volume.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.price_volume.input.product.value,
                LIVESTOCK_MARKET:this.price_volume.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定價量變化分析-種類切換時，要呈現的資訊
                this.setPriceVolumeTypeInfo(data);
                //設定價量變化分析-分類切換時，要呈現的資訊
                this.setPriceVolumeTypeSubInfo(data);
                //設定價量變化分析-商品名稱切換時，要呈現的資訊
                this.setPriceVolumeProductInfo(data);
                //設定價量變化分析-市場名稱切換時，要呈現的資訊
                this.setPriceVolumeMarketInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });   
        },
        //設定價量變化分析-種類切換時，要呈現的資訊
        setPriceVolumeTypeInfo:function(data)
        {
            //價量變化分析-選單-分類
            const TradeLivestockTypeSub = data.TradeLivestockTypeSub;
            //價量變化分析-選單-產品名稱
            const TradeLivestockName = data.TradeLivestockName;

            //選單部分
            switch(this.price_volume.input.type.value){
                case "牛":
                case "雞":
                case "鴨":
                case "鵝":        
                    //設定價量變化分析-分類
                    this.setPriceVolumeInputTypeSub(TradeLivestockTypeSub);     
                break;
                case "豬":
                case "羊":
                    //設定價量變化分析-產品名稱
                    this.setPriceVolumeInputProduct(TradeLivestockName);
                break;
            }
        },
        //取得畜牧其他資訊-種類切換時，要呈現的資訊
        getOtherInfoTypeInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockTypeInfo({

                LIVESTOCK_TYPE:this.other_info.input.type.value,
                LIVESTOCK_TYPE_SUB:this.other_info.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.other_info.input.product.value,
                LIVESTOCK_MARKET:this.other_info.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定畜牧其他資訊-種類切換時，要呈現的資訊
                this.setOtherInfoTypeInfo(data);
                //設定畜牧其他資訊-分類切換時，要呈現的資訊
                this.setOtherInfoTypeSubInfo(data);
                //設定畜牧其他資訊-商品名稱切換時，要呈現的資訊
                //this.setOtherInfoProductInfo(data);
                //設定畜牧其他資訊-市場名稱切換時，要呈現的資訊
                //this.setOtherInfoMarketInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //設定畜牧其他資訊-種類切換時，要呈現的資訊
        setOtherInfoTypeInfo:function(data){

            //畜牧其他資訊-選單-分類
            const TradeLivestockTypeSub = data.TradeLivestockTypeSub;
            //畜牧其他資訊-選單-產品名稱
            const TradeLivestockName = data.TradeLivestockName;

            //畜牧其他資訊-家畜產值(牛、豬、羊)
            const LivestockProductionQuantity = data.LivestockProductionQuantity;
            //畜牧其他資訊-家畜飼養場數(種類)(牛、豬、羊)
            const LivestockFieldQuantity = data.LivestockFieldQuantity;
            //畜牧其他資訊-家畜飼養頭數(牛、豬、羊)
            const LivestockFeedQuantity = data.LivestockFeedQuantity;

            //畜牧其他資訊-家禽產值(雞、鴨、鵝)
            const PoultryProductionQuantity = data.PoultryProductionQuantity;
            //畜牧其他資訊-家禽供應屠宰隻數(雞、鴨、鵝)
            const PoultrySlaughterQuantity = data.PoultrySlaughterQuantity;

            //畜牧其他資訊-家禽飼養場數(種類)(雞、鴨、鵝)
            const PoultryFieldQuantity = data.PoultryFieldQuantity;
            //畜牧其他資訊-家禽飼養場數(種類)(雞、鴨、鵝)
            const PoultryFeedQuantity = data.PoultryFeedQuantity;

            //選單部分
            switch(this.other_info.input.type.value){
                case "牛":
                case "雞":
                case "鴨":
                case "鵝":        
                    //畜牧其他資訊-分類
                    this.setOtherInfoInputTypeSub(TradeLivestockTypeSub);    
                break;
                case "豬":
                case "羊":
                    //畜牧其他資訊-產品名稱
                    this.setOtherInfoInputProduct(TradeLivestockName);
                break;
            }

            //報表部分(屠宰隻數)
            switch(this.other_info.input.type.value){
                case "雞":
                case "鴨":
                case "鵝":
                    //畜牧其他資訊-家禽供應屠宰隻數(雞、鴨、鵝)              
                    this.setPoultrySlaughterQuantity(PoultrySlaughterQuantity); 
                break;
            }
    
            //報表部分(產值)
            switch(this.other_info.input.type.value){
                case "牛":
                case "豬":
                case "羊":
                    //畜牧其他資訊-家畜產值(牛、豬、羊)
                    this.setLivestockProductionQuantity(LivestockProductionQuantity);
                break;
                case "雞":
                case "鴨":
                case "鵝":
                    //畜牧其他資訊-家禽產值(雞、鴨、鵝)
                    this.setPoultryProductionQuantity(PoultryProductionQuantity);
                break;
            }

            //報表部分(場數)
            switch(this.other_info.input.type.value){
                case "牛":
                case "豬":
                case "羊":
                    //畜牧其他資訊-家畜飼養場數(種類)(牛、豬、羊)
                    this.setLivestockFieldQuantity(LivestockFieldQuantity);
                break;
                case "雞":
                case "鴨":
                case "鵝":
                    //畜牧其他資訊-家禽飼養場數(種類)(雞、鴨、鵝)
                    this.setPoultryFieldQuantity(PoultryFieldQuantity);   
                break;
            }

            //報表部分(頭數、隻數)
            switch(this.other_info.input.type.value){
                case "牛":
                case "豬":
                case "羊":
                    //畜牧其他資訊-家畜飼養頭數(牛、豬、羊)
                    this.setLivestockFeedQuantity(LivestockFeedQuantity);
                break;
                case "雞":
                case "鴨":
                case "鵝":
                    //畜牧其他資訊-家禽飼養隻數(種類)(雞、鴨、鵝)
                    this.setPoultryFeedQuantity(PoultryFeedQuantity);  
                break;
            }
        },




        //取得當日交易行情-分類切換時，要呈現的資訊
        getTradingQuotesTypeSubInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockTypeSubInfo({

                LIVESTOCK_TYPE:this.trading_quotes.input.type.value,
                LIVESTOCK_TYPE_SUB:this.trading_quotes.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.trading_quotes.input.product.value,
                LIVESTOCK_MARKET:this.trading_quotes.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定當日交易行情-分類切換時，要呈現的資訊
                this.setTradingQuotesTypeSubInfo(data);
                //設定當日交易行情-商品名稱切換時，要呈現的資訊
                this.setTradingQuotesProductInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        },
        //設定當日交易行情-分類切換時，要呈現的資訊
        setTradingQuotesTypeSubInfo:function(data){

            //當日交易行情-選單-產品名稱
            const TradeLivestockName= data.TradeLivestockName;
    
            //選單部分
            switch(this.trading_quotes.input.type.value){
                case "牛":
                case "雞":
                case "鴨":
                case "鵝":        
                    //設定當日交易行情-產品名稱
                    this.setTradingQuotesInputProduct(TradeLivestockName);
                break;
            }
        },
        //取得價量變化分析-分類切換時，要呈現的資訊
        getPriceVolumeTypeSubInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockTypeSubInfo({

                LIVESTOCK_TYPE:this.price_volume.input.type.value,
                LIVESTOCK_TYPE_SUB:this.price_volume.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.price_volume.input.product.value,
                LIVESTOCK_MARKET:this.price_volume.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定價量變化分析-分類切換時，要呈現的資訊
                this.setPriceVolumeTypeSubInfo(data);
                //設定價量變化分析-商品名稱切換時，要呈現的資訊
                this.setPriceVolumeProductInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        },
        //設定價量變化分析-分類切換時，要呈現的資訊
        setPriceVolumeTypeSubInfo:function(data){
            //價量變化分析-選單-產品名稱
            const TradeLivestockName= data.TradeLivestockName;        
            //選單部分
            switch(this.price_volume.input.type.value){
                case "牛":
                case "雞":
                case "鴨":
                case "鵝":        
                    //設定價量變化分析-產品名稱
                    this.setPriceVolumeInputProduct(TradeLivestockName);
                break;
            }
        },
        //取得畜牧其他資訊-分類切換時，要呈現的資訊
        getOtherInfoTypeSubInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockTypeSubInfo({

                LIVESTOCK_TYPE:this.other_info.input.type.value,
                LIVESTOCK_TYPE_SUB:this.other_info.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.other_info.input.product.value,
                LIVESTOCK_MARKET:this.other_info.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定畜牧其他資訊-分類切換時，要呈現的資訊
                this.setOtherInfoTypeSubInfo(data);
                //設定畜牧其他資訊-商品名稱切換時，要呈現的資訊
                this.setOtherInfoProductInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        },
        //設定畜牧其他資訊-分類切換時，要呈現的資訊
        setOtherInfoTypeSubInfo:function(data){

            //畜牧其他資訊-選單-產品名稱
            const TradeLivestockName = data.TradeLivestockName;

            //畜牧其他資訊-家畜飼養場數(分類)(乳牛、肉牛)
            const LivestockFieldQuantity2 = data.LivestockFieldQuantity2;

            //畜牧其他資訊-家禽飼養場數(分類)(白肉雞、紅羽土雞、黑羽土雞、土番鴨)
            const PoultryFieldQuantity2 = data.PoultryFieldQuantity2;

            //畜牧其他資訊-家禽飼養隻數(種類)(雞、鴨、鵝)
            const PoultryFeedQuantity2 = data.PoultryFeedQuantity2;
            
            //選單部分
            switch(this.other_info.input.type.value){
                case "牛":
                case "雞":
                case "鴨":
                case "鵝":        
                    //設定畜牧其他資訊-產品名稱
                    this.setOtherInfoInputProduct(TradeLivestockName);
                break;
            }

            //報表部分(場數)
            switch(this.other_info.input.type.value){
                case "牛":
                    //當日交易行情-家畜飼養場數(分類)(乳牛、肉牛)
                    this.setLivestockFieldQuantity2(LivestockFieldQuantity2);
                break;
                case "雞":
                case "鴨":
                case "鵝":  
                    //當日交易行情-家禽飼養場數(分類)(白肉雞、紅羽土雞、黑羽土雞、土番鴨)
                    this.setPoultryFieldQuantity2(PoultryFieldQuantity2);
                break;
            }

            //報表部分(隻數)
            switch(this.other_info.input.type.value){
                case "雞":
                    //當日交易行情-家禽飼養隻數(分類)(白肉雞)
                    this.setPoultryFeedQuantity2(PoultryFeedQuantity2);  
                break;
            }
        },


        //取得當日交易行情-商品名稱切換時，要呈現的資訊
        getTradingQuotesProductInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockProductInfo({

                LIVESTOCK_TYPE:this.trading_quotes.input.type.value,
                LIVESTOCK_TYPE_SUB:this.trading_quotes.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.trading_quotes.input.product.value,
                LIVESTOCK_MARKET:this.trading_quotes.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定當日交易行情-商品名稱切換時，要呈現的資訊
                this.setTradingQuotesProductInfo(data);
                //設定當日交易行情-市場名稱切換時，要呈現的資訊
                this.setTradingQuotesMarketInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //設定當日交易行情-商品名稱切換時，要呈現的資訊
        setTradingQuotesProductInfo:function(data){

            //當日交易行情-選單-產品名稱
            const TradeLivestockMarket = data.TradeLivestockMarket;
            //當日交易行情-當日交易行情
            const TradeDay = data.TradeDay;

            //選單部分
            switch(this.trading_quotes.input.type.value){
                case "豬":
                case "羊":  
                    //設定當日交易行情-市場
                    this.setTradingQuotesInputMarket(TradeLivestockMarket);
                break;
            }

            //當日交易行情部分
            switch(this.trading_quotes.input.type.value){
                case "牛":
                case "雞":
                case "鴨":  
                case "鵝": 
                    //設定當日交易行情-近期交易資訊   
                    this.setTradeDay(TradeDay);  
                break;
            }

        },
        //取得價量變化分析-商品名稱切換時，要呈現的資訊
        getPriceVolumeProductInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockProductInfo({

                LIVESTOCK_TYPE:this.price_volume.input.type.value,
                LIVESTOCK_TYPE_SUB:this.price_volume.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.price_volume.input.product.value,
                LIVESTOCK_MARKET:this.price_volume.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定價量變化分析-商品名稱切換時，要呈現的資訊
                this.setPriceVolumeProductInfo(data);
                //設定價量變化分析-市場名稱切換時，要呈現的資訊
                this.setPriceVolumeMarketInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //設定價量變化分析-商品名稱切換時，要呈現的資訊
        setPriceVolumeProductInfo:function(data){
            //當日交易行情-選單-產品名稱
            //價量變化分析-選單-產品名稱
            const TradeLivestockMarket = data.TradeLivestockMarket;

            //價量變化分析-一周交易行情
            const TradeWeek = data.TradeWeek;
            //價量變化分析-月交易均價
            const TradeMonth = data.TradeMonth;
            //價量變化分析-年交易均價
            const TradeYear = data.TradeYear;

            switch(this.price_volume.input.type.value){
                case "豬":
                case "羊":  
                    //設定價量變化分析-市場
                    this.setPriceVolumeInputMarket(TradeLivestockMarket); 
                break;
            }

            //一周交易行情部分
            switch(this.price_volume.input.type.value){
                case "牛":
                case "雞":
                case "鴨": 
                case "鵝": 
                    //設定當日交易行情-一周交易均價變化圖(沒有交易量)
                    this.setTradeWeekNoColumn(TradeWeek);  
                break;
            }

            //月交易均價部分
            switch(this.price_volume.input.type.value){
                case "牛":
                case "雞":
                case "鴨":  
                case "鵝":   
                    //月交易均價
                    this.setTradeMonthNoColumn(TradeMonth);  
                break;
            }

            //年交易均價部分
            switch(this.price_volume.input.type.value){
                case "牛":
                case "雞":
                case "鴨":
                case "鵝":         
                    //年交易均價
                    this.setTradeYearNoColumn(TradeYear);   
                break;
            }
        },
        //取得畜牧其他資訊-商品名稱切換時，要呈現的資訊
        getOtherInfoProductInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockProductInfo({

                LIVESTOCK_TYPE:this.other_info.input.type.value,
                LIVESTOCK_TYPE_SUB:this.other_info.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.other_info.input.product.value,
                LIVESTOCK_MARKET:this.other_info.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定畜牧其他資訊-商品名稱切換時，要呈現的資訊
                this.setOtherInfoProductInfo(data);
                //設定畜牧其他資訊-市場名稱切換時，要呈現的資訊
                this.setOtherInfoMarketInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //設定畜牧其他資訊-商品名稱切換時，要呈現的資訊
        setOtherInfoProductInfo:function(data){

            //畜牧其他資訊-選單-產品名稱
            const TradeLivestockMarket = data.TradeLivestockMarket;

            switch(this.other_info.input.type.value){
                case "豬":
                case "羊":  
                    //設定畜牧其他資訊-市場
                    this.setOtherInfoInputMarket(TradeLivestockMarket);
                break;
            }

        },         

        //取得當日交易行情-市場名稱切換時，要呈現的資訊
        getTradingQuotesMarketInfo:function()
        {
            this.addUserActionLog({

                TokenID:sessionStorage.getItem("TokenID"),
                WebPage:"畜牧情報站",
                WebAction:"提交",
                ActionMemo:"當日交易行情",
                RequestData:JSON.stringify({

                    LIVESTOCK_TYPE:this.trading_quotes.input.type.value,
                    LIVESTOCK_TYPE_SUB:this.trading_quotes.input.type_sub.value,
                    LIVESTOCK_PRODUCT:this.trading_quotes.input.product.value,
                    LIVESTOCK_MARKET:this.trading_quotes.input.market.value,
                })
            });

            this.enableDefaultLoad();
            this.apiGetTradeLivestockMarketInfo({

                LIVESTOCK_TYPE:this.trading_quotes.input.type.value,
                LIVESTOCK_TYPE_SUB:this.trading_quotes.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.trading_quotes.input.product.value,
                LIVESTOCK_MARKET:this.trading_quotes.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定當日交易行情-市場名稱切換時，要呈現的資訊
                this.setTradingQuotesMarketInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //設定當日交易行情-市場名稱切換時，要呈現的資訊
        setTradingQuotesMarketInfo:function(data){

            //當日交易行情-當日交易行情
            const TradeDay = data.TradeDay;

            //當日交易行情部分
            switch(this.trading_quotes.input.type.value){
                case "豬":
                case "羊": 
                    //設定當日交易行情-近期交易資訊
                    this.setTradeDay(TradeDay);  
                break;
            }
        },
        //取得價量變化分析-市場名稱切換時，要呈現的資訊
        getPriceVolumeMarketInfo:function()
        {
            this.addUserActionLog({

                TokenID:sessionStorage.getItem("TokenID"),
                WebPage:"畜牧情報站",
                WebAction:"提交",
                ActionMemo:"價量變化分析",
                RequestData:JSON.stringify({

                    LIVESTOCK_TYPE:this.price_volume.input.type.value,
                    LIVESTOCK_TYPE_SUB:this.price_volume.input.type_sub.value,
                    LIVESTOCK_PRODUCT:this.price_volume.input.product.value,
                    LIVESTOCK_MARKET:this.price_volume.input.market.value,
                })
            });

            this.enableDefaultLoad();
            this.apiGetTradeLivestockMarketInfo({

                LIVESTOCK_TYPE:this.price_volume.input.type.value,
                LIVESTOCK_TYPE_SUB:this.price_volume.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.price_volume.input.product.value,
                LIVESTOCK_MARKET:this.price_volume.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定價量變化分析-市場名稱切換時，要呈現的資訊
                this.setPriceVolumeMarketInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //設定價量變化分析-市場名稱切換時，要呈現的資訊
        setPriceVolumeMarketInfo:function(data){
            //當日交易行情-一周交易行情
            const TradeWeek = data.TradeWeek;
            //價量變化分析-月交易均價
            const TradeMonth = data.TradeMonth;
            //價量變化分析-年交易均價
            const TradeYear = data.TradeYear;

            //一周交易行情部分
            switch(this.price_volume.input.type.value){
                case "豬":
                case "羊": 
                    //設定當日交易行情-一周交易均價變化圖
                    this.setTradeWeek(TradeWeek);
                break;
            }

            //月交易均價部分
            switch(this.price_volume.input.type.value){
                case "豬":
                case "羊": 
                    //月交易均價
                    this.setTradeMonth(TradeMonth);  
                break;
            }

            //年交易均價部分
            switch(this.price_volume.input.type.value){
                case "豬":
                case "羊": 
                    //年交易均價
                    this.setTradeYear(TradeYear); 
                break;
            }
        },
        //取得畜牧其他資訊-市場名稱切換時，要呈現的資訊
        getOtherInfoMarketInfo:function()
        {
            this.enableDefaultLoad();
            this.apiGetTradeLivestockMarketInfo({

                LIVESTOCK_TYPE:this.other_info.input.type.value,
                LIVESTOCK_TYPE_SUB:this.other_info.input.type_sub.value,
                LIVESTOCK_PRODUCT:this.other_info.input.product.value,
                LIVESTOCK_MARKET:this.other_info.input.market.value,
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                //設定畜牧其他資訊-市場名稱切換時，要呈現的資訊
                this.setOtherInfoMarketInfo(data);
                this.disableDefaultLoad();
            })
            .catch((err)=> {
                console.log(err);
                this.disableDefaultLoad();
            });
        
        },
        //設定畜牧其他資訊-市場名稱切換時，要呈現的資訊
        setOtherInfoMarketInfo:function(data){

            console.log(data);

            //當日交易行情-當日交易行情
            //const TradeDay = data.TradeDay;
            //當日交易行情-一周交易行情
            //const TradeWeek = data.TradeWeek;
            //當日交易行情部分
            switch(this.other_info.input.type.value){
                case "豬":
                case "羊": 
                    //設定當日交易行情-近期交易資訊
                    //this.setTradeDay(TradeDay);  
                break;
            }
            //一周交易行情部分
            switch(this.other_info.input.type.value){
                case "豬":
                case "羊": 
                    //設定當日交易行情-一周交易均價變化圖
                    //this.setTradeWeek(TradeWeek);
                break;
            }
        },


        //設定當日交易行情-近期交易資訊
        setTradeDay:function(TradeDay){

            //當日交易行情
            if(TradeDay.length > 0)
            {
                this.trading_quotes.trade_day.date.value = TradeDay[0].T_DATE;
                this.trading_quotes.trade_day.price_avg.value = TradeDay[0].PRICE;
                this.trading_quotes.trade_day.volume.value = TradeDay[0].VOLUME;
                this.trading_quotes.trade_day.is_result = true;
            }
            else
            {
                this.trading_quotes.trade_day.is_result = false;
            }
        },
        //設定當日交易行情-一周交易均價變化圖
        setTradeWeek:function(TradeWeek)
        {
            if(TradeWeek.length > 0)
            {
                var column_week = [];
                var line_week = [];
                for(var i=0;i<TradeWeek.length;i++)
                {
                    column_week.push({
                        //交易日期
                        x:TradeWeek[i].T_DATE,
                        //交易量
                        y:this.getRounded(TradeWeek[i].VOLUME)
                    });

                    line_week.push({
                        //交易日期
                        x:TradeWeek[i].T_DATE,
                        //均價
                        y:this.getRounded(TradeWeek[i].PRICE)
                    });
                }

                window.ThreadTool.Delay(function(){
        
                    window.setChartIntelligenceTradingQuotesWeek("#chart_trading_quotes_week",{
                        column:column_week,
                        line:line_week
                    });

                },this.delay_ms_chart);
            } 
            else
            {
                this.price_volume.week.is_result = false;
            } 

        },
        //設定當日交易行情-一周交易均價變化圖(沒有交易量)
        setTradeWeekNoColumn:function(TradeWeek){

            if(TradeWeek.length > 0)
            {
                var line_week = [];
                for(var i=0;i<TradeWeek.length;i++)
                {
                    line_week.push({
                        //交易日期
                        x:TradeWeek[i].T_DATE,
                        //均價
                        y:this.getRounded(TradeWeek[i].PRICE)
                    });
                }

                window.ThreadTool.Delay(function(){
        
                    window.setChartIntelligenceTradingQuotesWeek("#chart_trading_quotes_week",{
                        column:null,
                        line:line_week
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.price_volume.week.is_result = false;
            } 
        },
        //設定月交易均價
        setTradeMonth:function(TradeMonth){

            if(TradeMonth.length > 0)
            {
                var column_month = [];
                var line_month = [];
                for(var i=0;i<TradeMonth.length;i++)
                {
                    column_month.push({
                        //交易日期
                        x:TradeMonth[i].T_YEAR_MONTH,
                        //交易量
                        y:this.getRounded(TradeMonth[i].VOLUME)
                    });

                    line_month.push({
                        //交易日期
                        x:TradeMonth[i].T_YEAR_MONTH,
                        //均價
                        y:this.getRounded(TradeMonth[i].PRICE)
                    });
                }

                this.price_volume.month.is_result = true;

                window.ThreadTool.Delay(function(){
        
                    window.setChartIntelligencePriceVolumeMonth("#chart_price_volume_month",{
                        column:column_month,
                        line:line_month
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.price_volume.month.is_result = false;
            }                  
        },
        //設定月交易均價(沒有交易量)
        setTradeMonthNoColumn:function(TradeMonth){

            if(TradeMonth.length > 0)
            {
                var line_month = [];
                for(var i=0;i<TradeMonth.length;i++)
                {
                    line_month.push({
                        //交易日期
                        x:TradeMonth[i].T_YEAR_MONTH,
                        //均價
                        y:this.getRounded(TradeMonth[i].PRICE)
                    });
                }

                this.price_volume.month.is_result = true;

                window.ThreadTool.Delay(function(){
        
                    window.setChartIntelligencePriceVolumeMonth("#chart_price_volume_month",{
                        column:null,
                        line:line_month
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.price_volume.month.is_result = false;
            }      
        },
        //設定年交易均價
        setTradeYear:function(TradeYear){

            if(TradeYear.length > 0)
            {
                var column_year = [];
                var line_year = [];
                for(var i=0;i<TradeYear.length;i++)
                {
                    column_year.push({
                        //交易日期
                        x:TradeYear[i].T_YEAR,
                        //交易量
                        y:this.getRounded(TradeYear[i].VOLUME)
                    });

                    line_year.push({
                        //交易日期
                        x:TradeYear[i].T_YEAR,
                        //均價
                        y:this.getRounded(TradeYear[i].PRICE)
                    });
                }

                this.price_volume.year.is_result = true;

                window.ThreadTool.Delay(function(){
        
                    window.setChartIntelligencePriceVolumeYear("#chart_price_volume_year",{
                        column:column_year,
                        line:line_year
                    });

                },this.delay_ms_chart);
            } 
            else
            {
                this.price_volume.year.is_result = false;
            }
        },
        //設定年交易均價(沒有交易量)
        setTradeYearNoColumn:function(TradeYear){

            if(TradeYear.length > 0)
            {
                var line_year = [];
                for(var i=0;i<TradeYear.length;i++)
                {
                    line_year.push({
                                //交易日期
                                x:TradeYear[i].T_YEAR,
                                //均價
                                y:this.getRounded(TradeYear[i].PRICE)
                    });
                }

                this.price_volume.year.is_result = true;

                window.ThreadTool.Delay(function(){
        
                    window.setChartIntelligencePriceVolumeYear("#chart_price_volume_year",{
                        column:null,
                        line:line_year
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.price_volume.year.is_result = false;
            } 
                
        },
        
        //設定家畜產值(牛、豬、羊)
        setLivestockProductionQuantity:function(LivestockProductionQuantity){

            if(LivestockProductionQuantity.length > 0)
            {
                var data_livestock_production_quantity = [];
                for(var i=0;i<LivestockProductionQuantity.length;i++)
                {
                    data_livestock_production_quantity.push({
                        //縣市
                        x:LivestockProductionQuantity[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(LivestockProductionQuantity[i].VALUE)
                    });
                }

                this.other_info.livestock_production_quantity.year = LivestockProductionQuantity[0].YEAR;
                this.other_info.livestock_production_quantity.animal = LivestockProductionQuantity[0].TYPE;
                this.other_info.livestock_production_quantity.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligenceLivestockProductionQuantity("#chart_intelligence_livestock_production_quantity",{
                        data:data_livestock_production_quantity,
                    });
                    
                },this.delay_ms_chart);
            }
            else
            {
                this.other_info.livestock_production_quantity.is_result = false;
            }

        },
        //設定家畜飼養場數(種類)(牛、豬、羊)
        setLivestockFieldQuantity:function(LivestockFieldQuantity){

            if(LivestockFieldQuantity.length > 0)
            {
                var data_livestock_field_quantity = [];
                for(var i=0;i<LivestockFieldQuantity.length;i++)
                {
                    data_livestock_field_quantity.push({
                        //縣市
                        x:LivestockFieldQuantity[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(LivestockFieldQuantity[i].VALUE)
                    });
                }

                this.other_info.livestock_field_quantity.year = LivestockFieldQuantity[0].YEAR;
                this.other_info.livestock_field_quantity.animal = LivestockFieldQuantity[0].TYPE;
                this.other_info.livestock_field_quantity.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligenceLivestockFieldQuantity("#chart_intelligence_livestock_field_quantity",{
                        data:data_livestock_field_quantity,
                    });
                    
                },this.delay_ms_chart);
            }
            else
            {
                this.other_info.livestock_field_quantity.is_result = false;
            }
        },
        //設定家畜飼養場數(分類)(乳牛、肉牛)
        setLivestockFieldQuantity2:function(LivestockFieldQuantity2){

            if(LivestockFieldQuantity2.length > 0)
            {
                var data_livestock_field_quantity2 = [];
                for(var i=0;i<LivestockFieldQuantity2.length;i++)
                {
                    data_livestock_field_quantity2.push({
                        //縣市
                        x:LivestockFieldQuantity2[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(LivestockFieldQuantity2[i].VALUE)
                    });
                }

                this.other_info.livestock_field_quantity2.year = LivestockFieldQuantity2[0].YEAR;
                this.other_info.livestock_field_quantity2.animal = LivestockFieldQuantity2[0].TYPE;
                this.other_info.livestock_field_quantity2.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligenceLivestockFieldQuantity2("#chart_intelligence_livestock_field_quantity2",{
                        data:data_livestock_field_quantity2,
                    });
                    
                },this.delay_ms_chart);
            }
            else
            {
                this.other_info.livestock_field_quantity2.is_result = false;
            }
        },
        //設定家畜飼養頭數(牛、豬、羊)
        setLivestockFeedQuantity:function(LivestockFeedQuantity){

            if(LivestockFeedQuantity.length > 0)
            {
                var data_livestock_feed_quantity = [];
                for(var i=0;i<LivestockFeedQuantity.length;i++)
                {
                    data_livestock_feed_quantity.push({
                        //縣市
                        x:LivestockFeedQuantity[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(LivestockFeedQuantity[i].VALUE)
                    });
                }

                this.other_info.livestock_feed_quantity.year = LivestockFeedQuantity[0].YEAR;
                this.other_info.livestock_feed_quantity.animal = LivestockFeedQuantity[0].TYPE;
                this.other_info.livestock_feed_quantity.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligenceLivestockFeedQuantity("#chart_intelligence_livestock_feed_quantity",{
                        data:data_livestock_feed_quantity,
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.other_info.livestock_feed_quantity.is_result = false;
            }
        },
        //設定家禽產值(雞、鴨、鵝)
        setPoultryProductionQuantity:function(PoultryProductionQuantity){

            if(PoultryProductionQuantity.length > 0)
            {
                var data_poultry_production_quantity = [];
                for(var i=0;i<PoultryProductionQuantity.length;i++)
                {
                    data_poultry_production_quantity.push({
                        //縣市
                        x:PoultryProductionQuantity[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(PoultryProductionQuantity[i].VALUE)
                    });
                }

                this.other_info.poultry_production_quantity.year = PoultryProductionQuantity[0].YEAR;
                this.other_info.poultry_production_quantity.animal = PoultryProductionQuantity[0].TYPE;
                this.other_info.poultry_production_quantity.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligencePoultryProductionQuantity("#chart_intelligence_poultry_production_quantity",{
                        data:data_poultry_production_quantity,
                    });
                    
                },this.delay_ms_chart);
            }
            else
            {
                this.other_info.poultry_production_quantity.is_result = false;
            }
        },
        //設定家禽供應屠宰隻數(雞、鴨、鵝)              
        setPoultrySlaughterQuantity:function(PoultrySlaughterQuantity){

            if(PoultrySlaughterQuantity.length > 0)
            {
                var data_poultry_slaughter_quantity = [];
                for(var i=0;i<PoultrySlaughterQuantity.length;i++)
                {
                    data_poultry_slaughter_quantity.push({
                        //縣市
                        x:PoultrySlaughterQuantity[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(PoultrySlaughterQuantity[i].VALUE)
                    });
                }

                this.other_info.poultry_slaughter_quantity.year = PoultrySlaughterQuantity[0].YEAR;
                this.other_info.poultry_slaughter_quantity.animal = PoultrySlaughterQuantity[0].TYPE;
                this.other_info.poultry_slaughter_quantity.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligencePoultrySlaughterQuantity("#chart_intelligence_poultry_slaughter_quantity",{
                        data:data_poultry_slaughter_quantity,
                    });
                    
                },this.delay_ms_chart);
            }
            else
            {
                this.other_info.poultry_slaughter_quantity.is_result = false;
            }
            
        },
        //設定家禽飼養場數(種類)(雞、鴨、鵝)
        setPoultryFieldQuantity:function(PoultryFieldQuantity){

            if(PoultryFieldQuantity.length > 0)
            {
                var data_poultry_field_quantity = [];
                for(var i=0;i<PoultryFieldQuantity.length;i++)
                {
                    data_poultry_field_quantity.push({
                        //縣市
                        x:PoultryFieldQuantity[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(PoultryFieldQuantity[i].VALUE)
                    });
                }

                this.other_info.poultry_field_quantity.year = PoultryFieldQuantity[0].YEAR;
                this.other_info.poultry_field_quantity.animal = PoultryFieldQuantity[0].TYPE;
                this.other_info.poultry_field_quantity.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligencePoultryFieldQuantity("#chart_intelligence_poultry_field_quantity",{
                        data:data_poultry_field_quantity,
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.other_info.poultry_field_quantity.is_result = false;
            } 
        },
        //設定家禽飼養場數(分類)(白肉雞、紅羽土雞、黑羽土雞、土番鴨)
        setPoultryFieldQuantity2:function(PoultryFieldQuantity2){

            if(PoultryFieldQuantity2.length > 0)
            {
                var data_poultry_field_quantity2 = [];
                for(var i=0;i<PoultryFieldQuantity2.length;i++)
                {
                    data_poultry_field_quantity2.push({
                        //縣市
                        x:PoultryFieldQuantity2[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(PoultryFieldQuantity2[i].VALUE)
                    });
                }

                this.other_info.poultry_field_quantity2.year = PoultryFieldQuantity2[0].YEAR;
                this.other_info.poultry_field_quantity2.animal = PoultryFieldQuantity2[0].TYPE;
                this.other_info.poultry_field_quantity2.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligencePoultryFieldQuantity2("#chart_intelligence_poultry_field_quantity2",{
                        data:data_poultry_field_quantity2,
                    });

                },this.delay_ms_chart);
            } 
            else
            {
                this.other_info.poultry_field_quantity2.is_result = false;
            }

        },
        //設定家禽飼養隻數(種類)(雞、鴨、鵝)
        setPoultryFeedQuantity:function(PoultryFeedQuantity){

            if(PoultryFeedQuantity.length > 0)
            {
                var data_poultry_feed_quantity = [];
                for(var i=0;i<PoultryFeedQuantity.length;i++)
                {
                    data_poultry_feed_quantity.push({
                        //縣市
                        x:PoultryFeedQuantity[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(PoultryFeedQuantity[i].VALUE)
                    });
                }

                this.other_info.poultry_feed_quantity.year = PoultryFeedQuantity[0].YEAR;
                this.other_info.poultry_feed_quantity.animal = PoultryFeedQuantity[0].TYPE;
                this.other_info.poultry_feed_quantity.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligencePoultryFeedQuantity("#chart_intelligence_poultry_feed_quantity",{
                        data:data_poultry_feed_quantity,
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.other_info.poultry_feed_quantity.is_result = false;
            }   

        },
        //設定家禽飼養隻數(分類)(白肉雞)
        setPoultryFeedQuantity2:function(PoultryFeedQuantity2){

            if(PoultryFeedQuantity2.length > 0)
            {
                var data_poultry_feed_quantity2 = [];
                for(var i=0;i<PoultryFeedQuantity2.length;i++)
                {
                    data_poultry_feed_quantity2.push({
                        //縣市
                        x:PoultryFeedQuantity2[i].CITY,
                        //產量(公噸)
                        y:this.getRounded(PoultryFeedQuantity2[i].VALUE)
                    });
                }

                this.other_info.poultry_feed_quantity2.year = PoultryFeedQuantity2[0].YEAR;
                this.other_info.poultry_feed_quantity2.animal = PoultryFeedQuantity2[0].TYPE;
                this.other_info.poultry_feed_quantity2.is_result = true;

                window.ThreadTool.Delay(function(){
                            
                    window.setChartIntelligencePoultryFeedQuantity2("#chart_intelligence_poultry_feed_quantity2",{
                        data:data_poultry_feed_quantity2,
                    });

                },this.delay_ms_chart);
            }
            else
            {
                this.other_info.poultry_feed_quantity2.is_result = false;
            } 

        },

    }
}
</script>